import React, {Component} from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import {Alert, Label} from 'reactstrap';
import {FaLock} from "react-icons/fa";
import { Spinner } from 'react-bootstrap';
import Breadcrumb from "../../../components/Layout/Breadcrumb";

class AdminSetting2FaPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            btnSubmit: false,
            error: false,
            messageError: '',
            errorForm: false,
            messageForm: '',
            loadPage: true,
            is2Fa: false,
            type2Fa: 2,
            step: 1,
            successForm: false,
            messageSuccess: '',
            isAccuracy: false,
            countdown: 5,
            password: '',
            pin: '',
            google2fa_url: '',
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.loadAgency();
    }

    loadAgency = () => {
        // let dataAuth = {
        //     username: process.env.REACT_APP_CLIENT_ID,
        //     password: process.env.REACT_APP_CLIENT_PASSWD,
        //     token: process.env.REACT_APP_KEY,
        // };
        axios.get( process.env.REACT_APP_API_URL + '/api/admin/getContent2FaByAgency',
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify({
                        username: process.env.REACT_APP_CLIENT_ID,
                        password: process.env.REACT_APP_CLIENT_PASSWD,
                        token: process.env.REACT_APP_KEY,
                    }),
                    'encryptKey': process.env.REACT_APP_ENCRYPT_KEY,
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        is2Fa: ref.data.is_2fa,
                        loadPage: false,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu đại lý thất bại',
                    loadPage: false,
                    name: '',
                })
            })
    }

    changeInput = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        this.setState({
            [name]: value,
        })
    }

    submit = () => {
        let step = this.state.step;
        let confirmCode = '';
        if (this.state.isAccuracy && this.state.step === 2) {
            const inputElements = [...document.querySelectorAll('input.code-input')]
            confirmCode = inputElements.map(({value})=>value).join('');
            if ( typeof(confirmCode) == 'undefined' ) {
                alert("Lỗi không nhập mã xác thực");
                return false;
            }
            else if ( !confirmCode.length ) {
                alert("Lỗi mã xác thực không được để trống");
                return false;
            }
        }

        this.setState({
            loadPage: true,
            btnSubmit: true
        })

        let form = {
            type2Fa: this.state.type2Fa,
            step: step,
            confirmCode: confirmCode,
            pin: this.state.pin
        }
        // console.log( form )
        // let dataAuth = {
        //     username: process.env.REACT_APP_CLIENT_ID,
        //     password: process.env.REACT_APP_CLIENT_PASSWD,
        //     token: process.env.REACT_APP_KEY,
        // };
        axios.put( process.env.REACT_APP_API_URL + '/api/admin/confirm2Fa', form,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify({
                        username: process.env.REACT_APP_CLIENT_ID,
                        password: process.env.REACT_APP_CLIENT_PASSWD,
                        token: process.env.REACT_APP_KEY,
                    }),
                    'encryptKey': process.env.REACT_APP_ENCRYPT_KEY,
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( !ref.data.error ) {
                    if (step === 1 && parseInt(this.state.type2Fa) === 1) {
                        this.setState({
                            loadPage: false,
                            step: ref.data.step,
                            isAccuracy: true,
                            btnSubmit: false,
                            errorForm: false,
                            messageForm: '',
                        });

                        const inputElements = [...document.querySelectorAll('input.code-input')]

                        inputElements.forEach((ele,index)=>{
                            ele.addEventListener('keydown',(e)=>{
                                // if the keycode is backspace & the current field is empty
                                // focus the input before the current. Then the event happens
                                // which will clear the "before" input box.
                                if(e.keyCode === 8 && e.target.value==='') inputElements[Math.max(0,index-1)].focus()
                            })
                            ele.addEventListener('input',(e)=>{
                                // take the first character of the input
                                // this actually breaks if you input an emoji like 👨‍👩‍👧‍👦....
                                // but I'm willing to overlook insane security code practices.
                                const [first,...rest] = e.target.value
                                e.target.value = first ?? '' // first will be undefined when backspace was entered, so set the input to ""
                                const lastInputBox = index===inputElements.length-1
                                const didInsertContent = first!==undefined
                                if(didInsertContent && !lastInputBox) {
                                    // continue to input the rest of the string
                                    inputElements[index+1].focus()
                                    inputElements[index+1].value = rest.join('')
                                    inputElements[index+1].dispatchEvent(new Event('input'))
                                }
                            })
                        })
                    }
                    else if ( step === 1 && parseInt(this.state.type2Fa) === 2 ) {
                        this.setState({
                            loadPage: false,
                            step: ref.data.step,
                            google2fa_url: ref.data.google2fa_url,
                            isAccuracy: true,
                            btnSubmit: false,
                            errorForm: false,
                            messageForm: '',
                        });
                    }
                    else if ( step === 2 || step === 4 ) {
                        this.setState({
                            loadPage: false,
                            step: ref.data.step,
                            isAccuracy: true,
                            btnSubmit: false,
                            successForm: true,
                            messageSuccess: ref.data.message,
                            errorForm: false,
                            messageForm: '',
                        });
                        let i = 4;
                        setInterval(() => {
                            if ( i >= 0) {
                                this.setState({
                                    countdown: i,
                                })
                                i--;
                            }
                        }, 1000);
                        // sau 3s redirect về trang login
                        setTimeout(() => {
                            this.props.logOut();
                        }, 4000);
                    }
                }
                else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    }
                    else {
                        this.setState({
                            errorForm: true,
                            messageForm: ref.data.message,
                            loadPage: false,
                            btnSubmit: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    errorForm: true,
                    messageForm: 'Xác thực 2 yếu tố thất bại',
                    loadPage: false,
                    btnSubmit: false,
                    name: '',
                })
            })
    }

    submitOff = () => {
        this.setState({
            loadPage: true,
            btnSubmit: true
        })

        let form = {
            type2Fa: this.state.type2Fa,
            step: 5,
            password: this.state.password,
        }

        // let dataAuth = {
        //     username: process.env.REACT_APP_CLIENT_ID,
        //     password: process.env.REACT_APP_CLIENT_PASSWD,
        //     token: process.env.REACT_APP_KEY,
        // };
        axios.put( process.env.REACT_APP_API_URL + '/api/admin/confirm2Fa', form,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify({
                        username: process.env.REACT_APP_CLIENT_ID,
                        password: process.env.REACT_APP_CLIENT_PASSWD,
                        token: process.env.REACT_APP_KEY,
                    }),
                    'encryptKey': process.env.REACT_APP_ENCRYPT_KEY,
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( !ref.data.error ) {
                    this.setState({
                        loadPage: false,
                        step: 1,
                        isAccuracy: true,
                        btnSubmit: false,
                        errorForm: true,
                        messageForm: ref.data.message,
                        is2Fa: false,
                    });
                }
                else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    }
                    else {
                        this.setState({
                            errorForm: true,
                            messageForm: ref.data.message,
                            loadPage: false,
                            btnSubmit: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    errorForm: true,
                    messageForm: 'Xác thực 2 yếu tố thất bại',
                    loadPage: false,
                    btnSubmit: false,
                    name: '',
                })
            })
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <Breadcrumb title={"Xác thực 2 yếu tố"} page={"Đại lý"}
                                        icon={<FaLock className="breadcrumb-icon"/>}/>
                            {
                                this.state.error ? (
                                    <Alert color="danger">
                                        { this.state.messageError }
                                    </Alert>
                                ) : (
                                    <div className="col-md-6 marginAuto">
                                        <div className="card card-info">
                                            <div className="card-header">
                                                {
                                                    !this.state.is2Fa ? (
                                                        <h3 className="card-title text-center">Thiết lập xác thực 2 yếu tố</h3>
                                                    ) : (
                                                        <h3 className="card-title text-center">Tắt xác thực 2 yếu tố</h3>
                                                    )
                                                }

                                            </div>
                                            <div className="card-body">
                                                {
                                                    this.state.errorForm ? (
                                                        <Alert color="danger">
                                                            { this.state.messageForm }
                                                        </Alert>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                                {
                                                    this.state.successForm ? (
                                                        <Alert color="success">
                                                            { this.state.messageSuccess }
                                                        </Alert>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                                {
                                                    !this.state.is2Fa ? (
                                                        <>
                                                            {
                                                                !this.state.successForm ? (
                                                                    <>
                                                                        <div className="form-group">
                                                                            <Label for="type2Fa">Chọn loại xác thực</Label>
                                                                            <select name="type2Fa" id="type2Fa" className="form-control"
                                                                                    defaultValue={ this.state.type2Fa }
                                                                                    onChange={ this.changeInput }
                                                                            >
                                                                                <option value="" disabled={true}>Chọn loại xác thực</option>
                                                                                <option value="2">Xác thực bằng Google Authenticator</option>
                                                                                <option value="1">Xác thực bằng Email</option>
                                                                            </select>
                                                                        </div>
                                                                        {
                                                                            this.state.isAccuracy && this.state.step === 2 ? (
                                                                                <>
                                                                                    <div className="notication-confirm">
                                                                                        <div className="bg-success text-light p-2 rounded">
                                                                                            Yêu cầu xác thực 2 bước thành công
                                                                                        </div>
                                                                                        <div className="mt-2">
                                                                                            Vui lòng kiểm tra email để lấy mã xác
                                                                                            nhận và nhập vào ô bên dưới để xác thực
                                                                                            phương thức xác thực.
                                                                                        </div>
                                                                                        <div className="text-danger">
                                                                                            Lưu ý: sau khi xác nhận thì tài khoản sẽ
                                                                                            bị đăng xuất và chức năng 2FA bắt đầu
                                                                                            hoạt động
                                                                                        </div>
                                                                                    </div>
                                                                                    <fieldset className='number-code mt-2 mb-3'>
                                                                                        <legend className="title-verify">Mã xác
                                                                                            thực
                                                                                        </legend>
                                                                                        <div className="text-center p-2">
                                                                                            <input name='code'
                                                                                                   className='code-input' required/>
                                                                                            <input name='code'
                                                                                                   className='code-input' required/>
                                                                                            <input name='code'
                                                                                                   className='code-input' required/>
                                                                                            <input name='code'
                                                                                                   className='code-input' required/>
                                                                                            <input name='code'
                                                                                                   className='code-input' required/>
                                                                                            <input name='code'
                                                                                                   className='code-input' required/>
                                                                                        </div>
                                                                                    </fieldset>
                                                                                </>
                                                                            ) : (
                                                                                <></>
                                                                            )
                                                                        }
                                                                        {
                                                                            this.state.isAccuracy && this.state.step === 4 ? (
                                                                                <>
                                                                                    <div className="fa-form-type-2 mt-4">
                                                                                        <p className="fa-type-p">1.Quét mã vạch này
                                                                                            bằng ứng dụng Google Authenticator của
                                                                                            bạn</p>
                                                                                        <div className="pt-2 pb-4">
                                                                                            <div
                                                                                                className="text-center"
                                                                                                dangerouslySetInnerHTML={{ __html: this.state.google2fa_url }}
                                                                                            />
                                                                                        </div>
                                                                                        <p className="fa-type-p">2.Nhập mã pin để
                                                                                            kích hoạt Google Authenticator 2FA</p>
                                                                                        <div className="form-group mb-3">
                                                                                            <input className="form-control"
                                                                                                   type="text"
                                                                                                   name ="pin"
                                                                                                   id="pin"
                                                                                                   placeholder="Nhập mã ping"
                                                                                                   defaultValue={ this.state.pin }
                                                                                                   onChange={ this.changeInput }
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                            ) : (
                                                                                <></>
                                                                            )
                                                                        }
                                                                    </>
                                                                ) : (
                                                                    <></>
                                                                )
                                                            }
                                                            <div className="form-group text-center">
                                                                {
                                                                    this.state.step === 3 ? (
                                                                            <button className="btn btn-danger"
                                                                                    onClick={ () => this.props.logOut() }
                                                                                    disabled={ this.state.btnSubmit }
                                                                            >
                                                                                Đăng xuất sau { this.state.countdown }s
                                                                            </button>
                                                                    ) : (
                                                                        <button className="btn btn-primary"
                                                                                onClick={ () => this.submit() }
                                                                                disabled={ this.state.btnSubmit }
                                                                        >
                                                                            Xác nhận
                                                                        </button>
                                                                    )
                                                                }
                                                            </div>
                                                        </>
                                                    ) : (
                                                        // <h3 className="card-title text-center">Tắt xác thực 2 yếu tố</h3>
                                                        <>
                                                            <div className="form-group text-center">
                                                                <span className="text-danger">
                                                                    Bạn có muốn tắt tính năng xác thực 2 yếu tố không?
                                                                </span>
                                                            </div>
                                                            <div className="form-group mb-3">
                                                                <fieldset className='number-code mt-2'>
                                                                    <legend className="title-verify">Nhập mật khẩu tài
                                                                        khoản
                                                                    </legend>
                                                                    <div>
                                                                        <input className="form-control ipt-off-2fa"
                                                                               type="password"
                                                                               name ="password"
                                                                               placeholder="Nhập mật khẩu tài khoản"
                                                                               defaultValue={ this.state.password }
                                                                               onChange={ this.changeInput }
                                                                        />
                                                                    </div>
                                                                </fieldset>
                                                            </div>
                                                            <div className="form-group text-center">
                                                                <button className="btn btn-primary"
                                                                        onClick={ () => this.submitOff() }
                                                                        disabled={ this.state.btnSubmit }
                                                                >
                                                                    Xác nhận
                                                                </button>
                                                            </div>
                                                        </>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({type : 'logOut'}))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AdminSetting2FaPage);